import { render, staticRenderFns } from "./FastOrdersModule.vue?vue&type=template&id=808cfeba"
import script from "./FastOrdersModule.vue?vue&type=script&lang=js"
export * from "./FastOrdersModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports